import Api from '@/assets/ts/Api';

export default class ConnectionUtils {

    private static initialized = false;
    private static connectionStatus = true;
    private static changeListeners: ((status: boolean) => void)[] = [];

    private static init(): void {
        if (this.initialized) return;
        this.initialized = true;

        this.checkStatusByNavigator(); // initial check
        this.checkStatusByHealthApi(); // initial check
        setInterval(this.checkStatusByNavigator.bind(this), 500); // health check on navigator every 500 ms
        setInterval(this.checkStatusByHealthApi.bind(this), 5000); // health check on api every 5 seconds
    }

    private static checkStatusByNavigator(): void {
        if (!window.navigator.onLine && this.connectionStatus) {
            this.connectionStatus = false;
            this.changeListeners.forEach((listener) => listener(this.connectionStatus));
        }
    }

    private static checkStatusByHealthApi(): void {
        if (!window.navigator.onLine) return;

        Api.omb.healthGet()
            .then(() => {
                if (!this.connectionStatus) {
                    this.connectionStatus = true;
                    this.changeListeners.forEach((listener) => listener(this.connectionStatus));
                }
            })
            .catch(() => {
                if (this.connectionStatus) {
                    this.connectionStatus = false;
                    this.changeListeners.forEach((listener) => listener(this.connectionStatus));
                }
            });
    }

    public static addConnectionChangeListener(callback: (status: boolean) => void): boolean {
        this.changeListeners.push(callback);
        this.init();
        return this.connectionStatus;
    }

}
